import React, { useEffect, useRef } from 'react';
import { useDispatch, connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { APP_URL, CFCProps } from 'types';
import Utils from 'utilities/helper.util';
import { RootState } from 'redux/root.reducer';
import { authenticationStart, fetchUserStart } from 'redux/session/actions';
import { Loading } from 'carbon-components-react';
import createUrlBuilder from 'utilities/url.builder.utils';

const { REACT_APP_IDENTITY_WEB_URL, REACT_APP_IDENTITY_LOCATE_CLIENTID } =
  process.env;

export const Auth: React.FC<Props> = (props: Props) => {
  const dispatch: any = useDispatch();
  const { isAuthenticated, sessionIntialed, currentUser } = props;
  const history = useHistory();
  const location = useLocation<{ from?: string }>();
  const queryParams = new URLSearchParams(location.search);
  const returnWithToken = useRef(queryParams.has('token'));

  useEffect(() => {
    if (isAuthenticated && !Utils.isObjectEmpty(currentUser)) {
      queryParams.has('redirect')
        ? history.push(queryParams.get('redirect') || '')
        : history.push(APP_URL.ROOT_URL);
    } else {
      if (!returnWithToken.current && sessionIntialed) {
        const redirectPath = location.state?.from
          ? `redirect=${location.state.from}`
          : '';
        const urlBuilder = createUrlBuilder(
          `${REACT_APP_IDENTITY_WEB_URL}/login`
        );
        REACT_APP_IDENTITY_LOCATE_CLIENTID &&
          urlBuilder.addParameter(
            'clientId',
            REACT_APP_IDENTITY_LOCATE_CLIENTID
          );
        urlBuilder.addParameter(
          'return',
          `${location.pathname}?${redirectPath}`
        );
        window.location.href = urlBuilder.toString();
      }
    }
  }, [
    isAuthenticated,
    currentUser,
    sessionIntialed,
    history,
    location,
    queryParams
  ]);

  useEffect(() => {
    if (!isAuthenticated && !sessionIntialed && !returnWithToken.current) {
      dispatch(fetchUserStart());
    }
  }, [isAuthenticated, sessionIntialed, dispatch]);

  useEffect(() => {
    if (queryParams.has('token')) {
      dispatch(authenticationStart(queryParams.get('token') || ''));
      queryParams.delete('token');
      history.replace({ search: queryParams.toString() });
    }
  }, [dispatch, queryParams, history]);

  return <Loading withOverlay={true} />;
};

Auth.displayName = 'Auth';

const mapStateToProps = ({ session }: RootState) => ({
  isAuthenticated: session.isAuthenticated,
  sessionIntialed: session.initial,
  currentUser: session.currentUser
});

const connector = connect(mapStateToProps);
type Props = CFCProps<typeof connector>;
export default React.memo(connector(Auth));
